import {Controller} from '@hotwired/stimulus';
import {loadStripe} from '@stripe/stripe-js';

/**
 * Chargement de stripe (il est recommandé de le charger sur toutes les pages)
 * + formulaire stripe quand la target est spécifiée
 */
export default class extends Controller {
  static targets = ['container'];
  static values = {
    enabled: {
      type: Boolean,
      default: true,
    },
    key: String,
    clientSecret: String,
  };

  connect() {
    if (!this.enabledValue) {
      return;
    }

    loadStripe(this.keyValue).then((stripe) => {
      this.stripeLoaded(stripe);
    });
  }

  stripeLoaded(stripe) {
    if (!this.hasContainerTarget) {
      return;
    }

    stripe.createEmbeddedCheckoutPage({
      clientSecret: this.clientSecretValue,
    }).then((checkout) => {
      this.checkout = checkout;
      this.checkout.mount(this.containerTarget);
    });
  }

  disconnect() {
    if (this.checkout) {
      this.checkout.unmount();
      this.checkout.destroy();
      this.checkout = null;
    }
  }
}
